/** Default push-to-talk key: function key avoids browser modifier conflicts. */
export const DEFAULT_DICTATION_PTT_KEY = 'F8';
export function normalizePttKeyCodes(pttKeyCode) {
    if (!pttKeyCode)
        return [DEFAULT_DICTATION_PTT_KEY];
    return typeof pttKeyCode === 'string' ? [pttKeyCode] : [...pttKeyCode];
}
export function formatPttKeyLabel(pttKeyCodes) {
    if (pttKeyCodes.length === 1) {
        const code = pttKeyCodes[0];
        if (/^F\d+$/.test(code))
            return code;
        if (code === 'ControlLeft' || code === 'ControlRight') {
            return code === 'ControlRight' ? 'Right Ctrl' : 'Left Ctrl';
        }
        return code;
    }
    if (pttKeyCodes.includes('ControlLeft') && pttKeyCodes.includes('ControlRight')) {
        return 'Ctrl';
    }
    return pttKeyCodes.join(' / ');
}
